<yc-modal
  [modalHeader]="'common:hdrNoProgramsAvailable' | ycI18n: 'No Programs Available'"
  [primaryButtonText]="'common:textViewMyApplications' | ycI18n: 'View my applications'"
  (onPrimaryClick)="closeModal.emit(true)">
  <yc-rich-text-display [html]="failMessage"></yc-rich-text-display>
</yc-modal>